module.exports = __webpack_public_path__ + "a22da0ff026cb572bb554dc06256f00e.svg";